module.exports = __webpack_public_path__ + "static/logo-agua-ee36038e729b6169c7d251f272de9ee7.svg";